import React, { FC } from "react";
const LoginButton: FC = () => {
    return (
        <>
            <a className="btn btn-success btn-sm d-flex flex-center" href="/auth/login"><i className="ki-duotone ki-entrance-left fs-2"><i className="path1"></i><i className="path2"></i><i className="path3"></i></i> Login</a>        
        </>
    )
}

export {LoginButton}